/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {EntryMedallion} from "../schedule/metadata/EntryMedallion";
import {CompetitionMetadata} from "../schedule/metadata/CompetitionMetadata";
import {StageSpriteUtils} from "../../shared/StageSpriteUtils";

export class EntryAward implements AwardDisplayable {
  entryId: string;
  studioId: string;
  name: string;
  description: string;
  awardId: string;
  icon: string;
  color: string;
  awardType: number;
  note?: string;
  awardTypeKey: string;

  placement: number = -1;
  score: number = -1;
  published: number = 0;
  groupOrder: number = 0;
  title: string;

  static fromAngularFireSnapshots(snapshots: any) : EntryAward[] {
    return snapshots.map(snap => this._fromAngularFireSnapshot(snap.key, snap.payload.val()));
  }

  private static _fromAngularFireSnapshot(key: string, payload: {awardKey, awardType, description, entryId, groupOrder,
    icon, iconColor, name, placement, published, score, studioId}) : EntryAward {

    let award = new EntryAward();

    award.awardId = key;
    award.awardType = payload.awardType;
    award.awardTypeKey = payload.awardKey;
    award.name = payload.name;
    award.title = award.name;
    award.published = payload.published;
    award.entryId = payload.entryId;
    award.studioId = payload.studioId;

    if (payload.placement) {
      award.placement = payload.placement;
    }
    if (payload.score) {
      award.score = payload.score;
    }


    if (!payload.description && payload.score) {
      award.description = payload.score && payload.score > 0 ? `Score of ${payload.score}` : '';
    } else {
      award.description = payload.description;
    }

    if (payload.groupOrder) {
      award.groupOrder = payload.groupOrder;
    }

    award.note = StageSpriteUtils.getPlacement(payload.placement);

    const icon: IconInfo = this._getIconInfo(payload);
    award.icon = icon.name;
    award.color = icon.color;

    return award;
  }

  private static _getIconInfo(payload: any) : IconInfo {
    // default icon
    let icon: IconInfo = {
      name: 'md-trophy',
      color: '#FFFFFF'
    };

    if (payload.icon) {
      icon.name = payload.icon;

      if (payload.iconColor) {
        icon.color = payload.iconColor;
      }

      return icon;
    }

    // defaults
    switch (payload.awardType) {
      case 3: // special
        icon.name = 'md-star';
        icon.color = '#FFFF00';
        break;
      case 4:
        icon.name = 'md-trophy';
        icon.color = '#cc0000';
        break;
    }

    if (payload.iconColor) {
      icon.color = payload.iconColor;
    }

    return icon;
  }

}

export interface IconInfo {
  name: string,
  color: string
}

export class EntryMedalAward implements AwardDisplayable {
  name: string;
  description: string;
  icon: string;
  color: string;
  awardType: number;
  note?: string;

  static readonly AWARD_TYPE = 1;

  static readonly iconName: string = 'md-ribbon';

  constructor(public entryId: string, public awardId: string, public medallion: EntryMedallion,
              public score: number = -1, public placement: number = 0, public published: number = 0) {

  }

  static fromAngularFireSnapshots(snapshots: any, metadata: CompetitionMetadata) : EntryMedalAward[] {
    return snapshots.map(snap => this._fromAngularFireSnapshot(snap.key, snap.payload.val(), metadata));
  }

  static _fromAngularFireSnapshot(key: string, payload:
    {medalId, score, placement, published}, metadata: CompetitionMetadata) : EntryMedalAward {

    let medallion: EntryMedallion = null;
    if (!payload.medalId) {
      medallion = metadata.getMedallionForScore(payload.score);
    } else {
      medallion = metadata.getMedallionById(payload.medalId);
    }

    let award = new EntryMedalAward(key, payload.medalId, medallion, payload.score, payload.placement, payload.published);
    award.name = medallion.description;
    award.awardId = medallion.id;
    award.description = payload.score && payload.score > 0 ? `Score of ${payload.score}` : '';
    award.icon = EntryMedalAward.iconName;
    award.color = medallion.color;
    award.awardType = EntryMedalAward.AWARD_TYPE;
    award.note = StageSpriteUtils.getPlacement(payload.placement);

    return award;
  }

}



// export class EntryTrophyAward {
//
//   static readonly AWARD_TYPE = 2;
//   static readonly iconName: string = 'md-trophy';
//
//
// }
//
// export class EntrySpecialAward {
//
//   static readonly AWARD_TYPE = 3;
//   static readonly iconName: string = 'md-star';
//   static readonly iconColor: string = '#FFFF00';
//
//   constructor(public entryId: string, public awardId: string, public name: string, public description: string, public isPublished: boolean = false) {
//
//   }
//
//   static fromEntrySnapshot(snap: any) {
//
//   }
//
// }

export interface AwardDisplayable {
  entryId: string,
  name: string,
  description: string,
  awardId: string,
  icon: string,
  color: string,
  awardType: number,
  note?: string
}



// WEBPACK FOOTER //
// ./src/models/awards/EntryAward.ts